/**
 * Top bar (APP-001 §14).
 *
 * Hosts the mobile navigation trigger (drawer) on small screens and the
 * AccountMenu on all screens. The mobile trigger is hidden at the lg
 * breakpoint where the persistent Sidebar takes over.
 */
import type { ReactNode } from 'react';
import { MobileNavigation } from './MobileNavigation';
import { AccountMenu } from './AccountMenu';
import { ThemeToggle } from './ThemeToggle';
import type { DashboardIdentityResponse } from '@/api/dashboard-types';

export function TopBar({
  identity,
  children,
}: {
  identity: DashboardIdentityResponse;
  children?: ReactNode;
}) {
  return (
    <header className="sticky top-0 z-30 flex h-14 items-center gap-3 border-b bg-surface/95 px-4 backdrop-blur supports-[backdrop-filter]:bg-surface/80">
      <MobileNavigation />
      <div className="flex-1">{children}</div>
      <div className="flex items-center gap-1">
        <ThemeToggle />
        <AccountMenu identity={identity} />
      </div>
    </header>
  );
}
